// Pick a readable text color (dark or white) for a given background.
// Light sub-calendar/member colors (yellow, peach, mint, pink…) need dark text;
// white-on-light was near-unreadable on small event chips and member badges.
// Non-hex inputs (e.g. a CSS var like var(--color-primary)) default to white.
export function readableText(bg) {
  if (typeof bg !== 'string' || bg[0] !== '#') return '#fff';
  let h = bg.slice(1);
  if (h.length === 3) h = h.split('').map((c) => c + c).join('');
  if (h.length < 6) return '#fff';
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return lum > 0.6 ? '#2C2A27' : '#fff';
}
